import React, { useState, useRef, useEffect } from 'react';
import DOBPicker from '../dobPicker/DOBPicker';
import commonConstant, { FIELD_TYPE } from '../commonConstant';
import './Field.scss';
import { thaiDate } from '../../utill.func';

const Field = ({
  type = FIELD_TYPE.Text,
  preIconPath = '/images/common/IDcardIcon.svg',
  preIconDisabledPath = preIconPath || '/images/common/IDcardIconDisabled.svg',
  isPickerOpen = false,
  onPickerClose,
  onDateSubmit,
  onDateDelete,
  dateValue,
  disableFutureDates = false,
  regex,
  showError = () => { },
  errorText = '',
  ...rest }) => {

  const [inputHasFocus, setInputHasFocus] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isOpen, setIsOpen] = useState(isPickerOpen);

  useEffect(() => { setIsOpen(isPickerOpen) }, [isPickerOpen]);

  const handlePickerClose = (...closeArgs) => {
    setIsOpen(false);
    onPickerClose && onPickerClose(...closeArgs);
  };

  const handleDateSubmit = (...closeArgs) => {
    setIsOpen(false);
    onDateSubmit && onDateSubmit(...closeArgs);
  };

  const handleDateDelete = (...closeArgs) => {
    setIsOpen(false);
    onDateDelete && onDateDelete(...closeArgs);
  };

  const handleFocus = () => {
    setInputHasFocus(true);
    setErrorMessage('');
    showError({ name: rest.name, error: '' })
  }

  const handleBlur = (event) => {
    setInputHasFocus(false);
    if (event.target.value && regex && !regex?.test(event.target.value)) {
      setErrorMessage(errorText);
      showError({ name: rest.name, error: errorText });
    };
  }


  const dateObj = new Date(dateValue).getTime() ? new Date(dateValue) : new Date();

  return <div className="field">
    <div className="field-input-wrapper" onClick={() => { setIsOpen(!isOpen) }}>
      <img alt="before-icon" src={inputHasFocus ? preIconPath : preIconDisabledPath} />
      <input
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...rest}
        {...type === FIELD_TYPE.Date ? { inputMode: 'none' } : {}}
        className={`field-input${type === FIELD_TYPE.Date && isOpen ? ' --isOpen' : ''}`} type={type}
      />
      {(type === FIELD_TYPE.Date || type === FIELD_TYPE.DropDown) &&
        <img alt="after-icon" src="/images/common/Arrow-down.svg" />}
      {type == FIELD_TYPE.Date && <DOBPicker
        disabled={rest.disabled}
        onClose={handlePickerClose}
        onSubmit={handleDateSubmit}
        onDelete={handleDateDelete}
        isOpen={isOpen}
        defaultValue={{ day: `${dateObj.getDate()}`, month: commonConstant.MONTHS.th[dateObj.getMonth()], year: dateObj.getFullYear() }}
        disableFutureDates={disableFutureDates}
        isThai
      />}
    </div>
    <div className="field-input-error">{errorMessage}</div>
  </div>
}

export default Field;
